module.exports = __webpack_public_path__ + "static/media/lotto-game.deb7984b.png";